import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateSchedulesCreateFormsControllerModule } from './controllers/TemplatesCreateSchedulesCreateFormsController';
import { TemplatesCreateSchedulesCreateFormsModalsCreateView } from './modals/create/create';

export const TemplatesCreateSchedulesCreateFormsView = angular
  .module('acme.view.application.templates.create.schedules.create.forms', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.switcher',
    TemplatesCreateSchedulesCreateFormsControllerModule,
    TemplatesCreateSchedulesCreateFormsModalsCreateView,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.schedules.create.forms',
      url: '/forms',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreateFormsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/forms/forms.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Schedule Form',
      },
      resolve: {
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.edit.forms',
      url: '/forms',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreateFormsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/forms/forms.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Schedule Forms',
      },
      resolve: {
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });
  }).name;
